import { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const USER_INVITE_GUEST_RESOURCE = "user" as const;
export const USER_INVITE_GUEST_OPERATION = "invite-guest" as const;
export const USER_INVITE_GUEST_API_PATH = `/v1/${USER_INVITE_GUEST_RESOURCE}/${USER_INVITE_GUEST_OPERATION}` as const;

export type MutationBody =
  paths[typeof USER_INVITE_GUEST_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type MutationResponse =
  paths[typeof USER_INVITE_GUEST_API_PATH]["post"]["responses"][201]["content"]["application/json"];

export const useUserInviteGuestMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<MutationResponse, Error, MutationBody>({
    mutationFn: async (invitation: MutationBody) => {
      const response = await alphartisApiAxios.post<MutationResponse>(USER_INVITE_GUEST_API_PATH, invitation);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [USER_INVITE_GUEST_RESOURCE],
      });
    },
  });
};
